export const normalizeRemoteTicketPhotoUrl = (value) => {
	if (typeof value !== 'string') {
		return null;
	}

	const normalized = value.trim();

	try {
		const parsedUrl = new URL(normalized);
		return ['http:', 'https:'].includes(parsedUrl.protocol) && parsedUrl.hostname
			? normalized
			: null;
	}
	catch (error) {
		return null;
	}
};

export const normalizeRemoteTicketPhotoUrls = (values) => {
	if (!Array.isArray(values)) {
		return null;
	}

	const normalizedValues = values.map(normalizeRemoteTicketPhotoUrl);
	if (normalizedValues.some(value => !value)) {
		return null;
	}

	return Array.from(new Set(normalizedValues));
};

export const isRemoteTicketPhotoUrl = value => Boolean(normalizeRemoteTicketPhotoUrl(value));

export const hasRemoteTicketPhoto = values => Boolean(Array.isArray(values) && values.some(isRemoteTicketPhotoUrl));
